import React, { useState, useCallback } from 'react';
import { FiSend } from 'react-icons/fi';

const ChatInput = ({ onSendMessage, isLoading }) => {
    const [inputText, setInputText] = useState('');
    
    const handleSend = useCallback(() => {
        if (!inputText || isLoading) return;
        onSendMessage(inputText, null); 
        setInputText('');
    }, [inputText, isLoading, onSendMessage]);

    const handleKeyPress = useCallback((e) => {
        if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSend();
        }
    }, [handleSend]);

    return (
        <div className="input-container">
            <input
                type="text"
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
                onKeyPress={handleKeyPress}
                placeholder="Write your message..."
                className="chat-input"
                disabled={isLoading}
            />
            <button 
                onClick={handleSend} 
                className="send-button"
                disabled={isLoading || !inputText}
            >
                <FiSend size={22} />
            </button>
        </div>
    );
};

export default ChatInput;